import { z } from "zod";
import { ROLES } from "../constants.js";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginInput = z.infer<typeof loginSchema>;

/** Création d'un compte client par l'admin. */
export const createClientSchema = z
  .object({
    email: z.string().email(),
    name: z.string().min(1).max(120),
    // Deux modes exclusifs : mot de passe fixé par l'admin, ou lien d'invitation.
    mode: z.enum(["password", "invite"]),
    password: z.string().min(8).max(200).optional(),
  })
  .refine((v) => v.mode !== "password" || !!v.password, {
    message: "password requis quand mode = 'password'",
    path: ["password"],
  });
export type CreateClientInput = z.infer<typeof createClientSchema>;

/** Ajout d'un utilisateur supplémentaire ayant accès à un mariage (par le propriétaire). */
export const inviteMemberSchema = z
  .object({
    email: z.string().email(),
    name: z.string().min(1).max(120),
    mode: z.enum(["password", "invite"]),
    password: z.string().min(8).max(200).optional(),
  })
  .refine((v) => v.mode !== "password" || !!v.password, {
    message: "password requis quand mode = 'password'",
    path: ["password"],
  });
export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;

/** Définition du mot de passe via un lien d'invitation. */
export const acceptInviteSchema = z.object({
  token: z.string().min(10),
  password: z.string().min(8).max(200),
});
export type AcceptInviteInput = z.infer<typeof acceptInviteSchema>;

/** Changement de mot de passe (1re connexion forcée ou volontaire). */
export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(8).max(200),
});
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;

/** Demande de lien de réinitialisation (« mot de passe oublié »). */
export const forgotPasswordSchema = z.object({
  email: z.string().email(),
});
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

/** Nouveau mot de passe via un lien de réinitialisation. */
export const resetPasswordSchema = z.object({
  token: z.string().min(10),
  password: z.string().min(8).max(200),
});
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export const sessionUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: z.enum(ROLES),
  mustChangePassword: z.boolean(),
});
export type SessionUser = z.infer<typeof sessionUserSchema>;
